var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "file-upload" },
    [
      _vm.mode === "DESIGN"
        ? _c(
            "div",
            { staticClass: "disabled-box" },
            [
              _c(
                "el-button",
                { staticClass: "btn-upload", attrs: { size: "mini" } },
                [_c("i", { staticClass: "icon-zip" }), _vm._v("上传附件")]
              ),
            ],
            1
          )
        : [
            !_vm.readerMode || _vm.perm === "E"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "upload-container",
                      class: {
                        "hide-upload":
                          _vm.maxNumber > 0 &&
                          _vm._value.length >= _vm.maxNumber,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            "file-list": _vm._value,
                            "show-file-list": false,
                            action: "#",
                            limit: _vm.maxNumber,
                            "with-credentials": "",
                            multiple: _vm.maxNumber !== 1,
                            "on-exceed": _vm.handleExceed,
                            data: _vm.uploadParams,
                            "auto-upload": true,
                            "on-preview": _vm.handlePreview,
                            "on-remove": _vm.handleRemove,
                            "before-upload": _vm.beforeUpload,
                            "http-request": _vm.uploadFile,
                            disabled:
                              _vm.perm === "R" ||
                              _vm.pendingApprovalUploads > 0,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              class:
                                _vm.perm === "R"
                                  ? "btn-upload btn-upload-disabled"
                                  : "btn-upload",
                              attrs: { size: "mini" },
                            },
                            [
                              _c("i", { staticClass: "icon-zip" }),
                              _vm._v("上传附件"),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("approval-attachment-list", {
                        ref: "attachments",
                        attrs: {
                          files: _vm._value,
                          removable:
                            _vm.perm !== "R" &&
                            _vm.perm !== "H" &&
                            !_vm.pendingApprovalUploads,
                        },
                        on: { remove: _vm.handleRemove },
                      }),
                      _vm.pendingApprovalUploads
                        ? _c("div", { staticClass: "upload-progress" }, [
                            _vm._v(
                              "正在上传 " +
                                _vm._s(_vm.pendingApprovalUploads) +
                                " 个附件，请稍候…"
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : [
                  _c("approval-attachment-list", {
                    ref: "attachments",
                    attrs: { files: _vm._value },
                  }),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }